"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeliveryFilters = useDeliveryFilters;
var _checkoutUtils = require("@ori/checkout-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _models = require("../../models");
/**
 * Helper hook for address filtering logic.
 * @obsolete Can be dropped later when flat selection UI is used in all markets.
 */
function useDeliveryFilters({
  activeAddressFilter,
  activeFilter,
  addressFilters,
  filters,
  isDisplayingAddresses,
  setActiveAddressFilter,
  setActiveFilter,
  setCurrentSuggestionsPage
}) {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    isAddingNewDelivery
  } = (0, _hooks.useAnalytics)();
  const defaultFilterValue = isDisplayingAddresses ? _constants.DEFAULT_ADDRESS_FILTER : _constants.DEFAULT_HISTORY_FILTER;
  const filterValue = (isDisplayingAddresses ? activeAddressFilter : activeFilter) ?? defaultFilterValue;
  function onFilterChange(filterName) {
    setActiveFilter(filterName);
    setCurrentSuggestionsPage(0);
    // analytics
    (0, _checkoutUtils.dispatchUserActionEvent)([_models.MetaHierarchy.DeliverySelection, isAddingNewDelivery.current ? _models.MetaHierarchy.FirstSelection : _models.MetaHierarchy.EditSelection, _models.MetaHierarchy.History, _models.MetaHierarchy.UseFilter]);
    (0, _logger.logDebug)(`Filter has been changed to ${filterName}`);
  }
  function onAddressFilterChange(filterName) {
    setActiveAddressFilter(filterName);
    setCurrentSuggestionsPage(0);
    // analytics
    (0, _checkoutUtils.dispatchUserActionEvent)([_models.MetaHierarchy.DeliverySelection, isAddingNewDelivery.current ? _models.MetaHierarchy.FirstSelection : _models.MetaHierarchy.EditSelection, _models.MetaHierarchy.Addresses, _models.MetaHierarchy.UseFilter]);
    (0, _logger.logDebug)(`Address filter has been changed to ${filterName}`);
  }
  const deliveryFilterProps = {
    defaultValue: defaultFilterValue,
    filters: isDisplayingAddresses ? addressFilters : filters,
    id: 'delivery-options-filter',
    isLabelVisible: true,
    label: formatMessage('filter'),
    menuProps: getTestIdProps(_models.TestId.DeliveryFilterPopup),
    onFilterChange: isDisplayingAddresses ? onAddressFilterChange : onFilterChange,
    value: filterValue,
    ...getTestIdProps(isDisplayingAddresses ? _models.TestId.DeliveryFilterAddress : _models.TestId.DeliveryFilter)
  };

  // make sure that the default values are always present to have correct filtering logic
  if (!deliveryFilterProps.filters.includes(defaultFilterValue)) {
    deliveryFilterProps.filters.push(defaultFilterValue);
  }

  // If the filters were empty in the delivery options, it doesn't make sense to try to filter
  // for anything & create additional requests for it. When only 1 value is present, it is just
  // the default filter value in this case.
  const isActiveFilter = deliveryFilterProps.filters.length > 1;
  return {
    deliveryFilterProps,
    filterValue,
    isActiveFilter
  };
}